export default "__VITE_ASSET__CaqghF_g__"